//@flow
import _ from 'lodash';
import * as React from 'react';
import { TableHeaderColumn } from 'react-bootstrap-table';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import ListagemPage from '../../components/templates/ListagemPage';
import { tableHelper } from '../../helpers/tableHelper';
import TopoTitleComponente from '../Topo/TopoTitleComponente';
import { reprocessamentoService } from '../../services/reprocessamento.service';
import ReprocessamentoEstoqueInternoCrudListFilter from './ReprocessamentoEstoqueInternoCrudListFilter';

const STATUS_LABELS = {
  PENDENTE: 'Pendente',
  ERRO_REPROCESSAMENTO: 'Erro no reprocessamento',
  RESOLVIDA: 'Resolvida',
};

const TIPO_LABELS = {
  ROLLBACK_RESERVA_PEDIDO: 'Rollback reserva pedido',
  ROLLBACK_BAIXA_PEDIDO: 'Rollback baixa pedido',
  ROLLBACK_NOTA_FISCAL: 'Rollback nota fiscal',
};

type State = {
  processandoLote: boolean,
  reprocessandoId: ?string,
};

class ReprocessamentoEstoqueInternoCrudList extends React.PureComponent<{}, State> {
  listagemPage: any;

  constructor(props) {
    super(props);

    this.state = {
      processandoLote: false,
      reprocessandoId: null,
    };

    this.columns = [
      { path: 'id', title: 'ID', isKey: true, hidden: true },
      {
        path: 'status',
        title: 'Status',
        width: '180px',
        customFormat: this.renderStatus,
      },
      {
        path: 'tipo',
        title: 'Tipo',
        width: '210px',
        customFormat: this.renderTipo,
      },
      {
        path: 'codigoCliente',
        title: 'Cliente',
        className: 'txtBold',
      },
      {
        path: 'numeroPedido',
        title: 'Pedido',
        className: 'txtBold',
      },
      {
        path: 'codigoProduto',
        title: 'Produto',
        className: 'txtBold',
      },
      {
        path: 'createdAt',
        title: 'Criada em',
        isDateTime: true,
        width: '180px',
      },
      {
        path: 'tentativasReprocessamento',
        title: 'Tentativas',
        width: '110px',
        customFormat: this.renderNumero,
      },
      {
        path: 'mensagem',
        title: 'Mensagem',
        width: '280px',
        customFormat: this.renderResumoTexto,
        expandFormat: this.renderTextoCompleto,
      },
      {
        path: 'ultimaMensagemReprocessamento',
        title: 'Último retorno',
        width: '280px',
        customFormat: this.renderResumoTexto,
        expandFormat: this.renderTextoCompleto,
      },
      {
        path: 'reprocessar',
        title: 'Ação',
        width: '150px',
        dataSort: false,
        customFormat: this.renderAcao,
      },
    ];
  }

  handleReprocessarPendentes = () => {
    if (!window.confirm('Deseja reprocessar todas as pendências abertas do estoque interno?')) {
      return;
    }

    this.setState({ processandoLote: true });

    reprocessamentoService.reprocessarPendenciasEstoqueInterno().then(
      (response) => {
        const resultado = response && response.data ? response.data : {};
        const total = resultado.total || 0;
        const ok = resultado.ok || 0;
        const erro = resultado.erro || 0;
        const mensagemBase = `Reprocessamento concluído. Total: ${total}. Sucesso: ${ok}. Erro: ${erro}.`;

        this.setState({ processandoLote: false }, this.atualizarTabela);

        if (erro > 0) {
          this.props.error({
            message:
              (resultado.mensagem ? resultado.mensagem + ' ' : '') + mensagemBase,
          });
          return;
        }

        this.props.success({
          message:
            (resultado.mensagem ? resultado.mensagem + ' ' : '') + mensagemBase,
        });
      },
      () => {
        this.setState({ processandoLote: false });
        this.props.error({
          message: 'Erro ao reprocessar pendências do estoque interno.',
        });
      },
    );
  };

  handleReprocessarPendencia = (row, event) => {
    if (event) {
      event.stopPropagation();
    }

    if (!window.confirm('Deseja reprocessar esta pendência de estoque interno?')) {
      return;
    }

    this.setState({ reprocessandoId: row.id });

    reprocessamentoService.reprocessarPendenciaEstoqueInterno(row.id).then(
      () => {
        this.setState({ reprocessandoId: null }, this.atualizarTabela);
        this.props.success({
          message: 'Pendência reprocessada com sucesso.',
        });
      },
      (error) => {
        const pendencia = error && error.response ? error.response.data : null;
        const mensagem =
          pendencia && pendencia.ultimaMensagemReprocessamento
            ? pendencia.ultimaMensagemReprocessamento
            : 'Erro ao reprocessar pendência do estoque interno.';

        this.setState({ reprocessandoId: null }, this.atualizarTabela);
        this.props.error({ message: mensagem });
      },
    );
  };

  atualizarTabela = () => {
    const listagemPage =
      this.listagemPage && this.listagemPage.getWrappedInstance
        ? this.listagemPage.getWrappedInstance()
        : this.listagemPage;

    if (listagemPage && listagemPage.updateTable) {
      listagemPage.updateTable();
    }
  };

  renderStatus = (cell, row, column) => {
    const valor = cell || _.get(row, column.path);
    let className = '';

    if (valor === 'RESOLVIDA') {
      className = 'txt_verde';
    } else if (valor === 'ERRO_REPROCESSAMENTO') {
      className = 'txt_vermelho';
    } else if (valor === 'PENDENTE') {
      className = 'txt_amarelo';
    }

    return (
      <div data-title={column.title} className={className}>
        {STATUS_LABELS[valor] || valor || '--'}
      </div>
    );
  };

  renderTipo = (cell, row, column) => {
    const valor = cell || _.get(row, column.path);

    return (
      <div data-title={column.title}>
        {TIPO_LABELS[valor] || valor || '--'}
      </div>
    );
  };

  renderResumoTexto = (cell, row, column) => {
    const valor = cell || _.get(row, column.path);
    const texto = valor ? String(valor).trim() : '';
    const resumo =
      texto && texto.length > 140 ? texto.substring(0, 140).trim() + '...' : texto;

    return (
      <div
        data-title={column.title}
        title={texto || ''}
        style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}
      >
        {resumo || '--'}
      </div>
    );
  };

  renderNumero = (cell, row, column) => {
    const valor = cell !== null && cell !== undefined ? cell : _.get(row, column.path);

    return <div data-title={column.title}>{valor !== null && valor !== undefined ? valor : '--'}</div>;
  };

  renderTextoCompleto = (cell, row, column) => {
    const valor = cell || _.get(row, column.path);
    const texto = valor ? String(valor).trim() : '';

    return (
      <div
        data-title={column.title}
        style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}
      >
        {texto || '--'}
      </div>
    );
  };

  renderAcao = (_cell, row, column) => {
    const bloqueado =
      this.state.processandoLote || this.state.reprocessandoId === row.id;
    const podeReprocessar = row && row.status !== 'RESOLVIDA';

    return (
      <div data-title={column.title}>
        <button
          type="button"
          className="btn btn-secondary btn-sm"
          disabled={!podeReprocessar || bloqueado}
          onClick={(event) => this.handleReprocessarPendencia(row, event)}
        >
          {this.state.reprocessandoId === row.id ? 'Processando...' : 'Reprocessar'}
        </button>
      </div>
    );
  };

  ExpandDetalhes = (row) => {
    const campos = [
      { label: 'Status', value: STATUS_LABELS[row.status] || row.status },
      { label: 'Tipo', value: TIPO_LABELS[row.tipo] || row.tipo },
      { label: 'Cliente', value: row.codigoCliente },
      { label: 'Pedido', value: row.numeroPedido },
      { label: 'Produto', value: row.codigoProduto },
      { label: 'Referência tipo', value: row.referenciaTipo },
      { label: 'Referência ID', value: row.referenciaId },
      { label: 'Origem', value: row.origem },
      { label: 'Criada em', value: tableHelper.renderCustom(row, row, { path: 'createdAt', title: 'Criada em', isDateTime: true }) },
      { label: 'Atualizada em', value: tableHelper.renderCustom(row, row, { path: 'updatedAt', title: 'Atualizada em', isDateTime: true }) },
      { label: 'Última tentativa', value: tableHelper.renderCustom(row, row, { path: 'ultimaTentativaReprocessamento', title: 'Última tentativa', isDateTime: true }) },
      { label: 'Resolvida em', value: tableHelper.renderCustom(row, row, { path: 'resolvidoEm', title: 'Resolvida em', isDateTime: true }) },
      { label: 'Tentativas', value: row.tentativasReprocessamento },
      { label: 'Última ação por', value: row.usuarioUltimaAcaoNome },
      { label: 'Mensagem', value: row.mensagem },
      { label: 'Último retorno', value: row.ultimaMensagemReprocessamento },
      { label: 'Payload', value: row.payload },
    ];

    return (
      <div style={{ padding: 12 }}>
        {campos.map((campo) => (
          <div
            key={campo.label}
            style={{
              display: 'grid',
              gridTemplateColumns: '220px 1fr',
              padding: '4px 0',
              borderBottom: '1px solid #eee',
            }}
          >
            <div style={{ fontWeight: 'bold' }}>{campo.label}</div>
            <div style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
              {campo.value !== null && campo.value !== undefined && campo.value !== ''
                ? campo.value
                : '--'}
            </div>
          </div>
        ))}
      </div>
    );
  };

  renderAcoesPesquisa = () => {
    return (
      <Button
        color="primary"
        size="sm"
        disabled={this.state.processandoLote}
        onClick={this.handleReprocessarPendentes}
      >
        {this.state.processandoLote
          ? 'Reprocessando pendências...'
          : 'Reprocessar pendências abertas'}
      </Button>
    );
  };

  render() {
    const tableColumns = _.map(this.columns, (column, index) => {
      const formatFn = column.customFormat
        ? column.customFormat
        : tableHelper.renderCustom;

      return (
        <TableHeaderColumn
          key={index}
          dataField={column.path}
          dataFormat={formatFn}
          formatExtraData={column}
          isKey={column.isKey}
          dataSort={column.dataSort !== false}
          hidden={column.hidden}
          width={column.width}
          columnClassName={column.className}
          className={column.className}
        >
          {column.title}
        </TableHeaderColumn>
      );
    });

    const estoqueInternoPendenciaService = {
      findByFiltro: reprocessamentoService.findPendenciasEstoqueInternoByFiltro,
    };

    return (
      <React.Fragment>
        <TopoTitleComponente
          mainTitle="Pendências de Estoque Interno"
          subTitle="Reprocessamento manual"
          canBack={true}
        />

        <ListagemPage
          ref={(ref) => {
            this.listagemPage = ref;
          }}
          key="reprocessamento-estoque-interno"
          pageFilter="reprocessamento-estoque-interno"
          title="Pendências de estoque interno"
          newButtonActionClick={() => {}}
          delete={() => {}}
          service={estoqueInternoPendenciaService}
          showNewButton={false}
          labelNewButton=""
          defaultOrder="createdAt"
          defaultDirection="desc"
          defaultFilter={{}}
          FormFilter={ReprocessamentoEstoqueInternoCrudListFilter}
          renderRightOfSearch={this.renderAcoesPesquisa}
          isExpandableRow={() => true}
          expandComponent={this.ExpandDetalhes}
          expandColumnOptions={{
            expandColumnVisible: true,
            expandColumnBeforeSelectColumn: true,
          }}
        >
          {tableColumns}
        </ListagemPage>
      </React.Fragment>
    );
  }
}

const mapDispatch = ({ alert: { success, error } }) => ({
  success: (msg) => success(msg),
  error: (msg) => error(msg),
});

export default connect(
  null,
  mapDispatch,
)(ReprocessamentoEstoqueInternoCrudList);
